import { Dispatcher } from 'flux';
import { FSA } from "flux-standard-action/lib";

import { Store } from "../../../../flux/Store";

interface State<D>
{
    draft: D;
}

export class EditStore<D, S extends State<D>> extends Store<S>
{
    // Each Entity edit store has a draft property inside it state
    // This helper method updates property of that draft
    // In Flux architecture state should be immutable, so we return new instance on every invocation
    protected draft(draft: Partial<D>)
    {
        return Object.assign({}, this.state, {
            draft: this.getDraft(draft)
        });
    }

    protected getDraft(draft: Partial<D>): D
    {
        const oldDraft = this.state ? this.state.draft : undefined;
        return Object.assign({},  oldDraft, draft);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/EditCreate/EditStore.ts